<div class="wm-orderby-container">
  <div class="fixed-header">
    <div class="group-header">
      <i class="wms wms-arrow-drop-down group-icon"></i>
      <span class="group-title"></span>
    </div>
  </div>
  <ul class="app-checkboxset list-group order-by">
    <ng-template ngFor let-key [ngForOf]="columns | keyvalue" let-i="index">
      <ng-template [ngIf]="key.key !== 'all'">
        <li class="checkbox app-checkbox group-header" title={{key.key}}>
          <i class="wms wms-arrow-drop-down group-icon"></i>
          <span class="group-title">{{key.key}}</span>
        </li>
      </ng-template>
<!--Temporary commenting, need to fix ng build issue    -->
      <ng-template ngFor let-dataKey [ngForOf]="$any(key.value).keys" let-j="index">
        <li class="checkbox app-checkbox">
          <div class="checkbox">
            <label class="app-checkboxset-label app-orderby">
              <input type="checkbox" [checked]="isSelected(dataKey.key)" (focus)="handleFocus()" (click)="handleInputClick($event.currentTarget, dataKey.key)"/>
              <span title={{dataKey.key}}>{{dataKey.title}}</span>
            </label>
            <button class="btn-transparent" (click)="handleButtonClick($event.currentTarget, dataKey.key)">
              <i class={{getIconClass(dataKey.key)}}></i>
            </button>
          </div>
        </li>
      </ng-template>
    </ng-template>
  </ul>
</div>
